/* eslint-disable */
import dataURLtoBlob from 'blueimp-canvas-to-blob';
import loadImage from 'blueimp-load-image';

const URL = window.URL || window.webkitURL;
// Get data from the cache.
const getCachedData = async (cacheName, url, audio) => {
  const cacheStorage = await caches.open(cacheName);
  const cachedResponse = await cacheStorage.match(url);
  if (!cachedResponse || !cachedResponse.ok) {
    const res = await fetch(url);
    if (res.ok) {
      await cacheStorage.add(url);
      let data;
      if (audio) {
        data = await res.arrayBuffer();
        data = new Blob([data], { type: 'audio/mpeg' });
      } else {
        data = await res.blob();
      }
      return { cached: false, file: URL.createObjectURL(data) };
    }
    if (url.indexOf('diary') > -1) {
      return null;
    }
    return { cached: false, file: `${SITE_URL}image/img_thumb.png` };
  }
  // eslint-disable-next-line no-return-await
  const data = await cachedResponse.blob();
  return { cached: true, file: URL.createObjectURL(data) };
};

const deleteOldCaches = async (currentCache) => {
  const keys = await caches.keys();
  keys.forEach((key) => {
    const isOurCache = key.substr(0, 7) === 'assets-';

    if (isOurCache && currentCache !== key) {
      caches.delete(key);
    }
  });
};

const asyncLoadImage = (image) =>
  new Promise((res) => {
    loadImage.parseMetaData(image, (metadata) => {
      if (metadata.exif) {
        const name = metadata.exif.getName(0x0112); // "Orientation"
        const orientationText = metadata.exif.getText(name); // e.g. "Rotate 90° CW"
        console.log(`${name} | ${orientationText}`);
      }
      loadImage(
        image,
        (result) => {
          if (result.type !== 'error') {
            return res(result);
          }
          return res(null);
        },
        {
          canvas: true,
          crop: true,
          // aspectRatio: 1 / 1,
          pixelRatio: 1,
          downsamplingRatio: 0.5,
          orientation: true,
          maxWidth: 800,
          maxHeight: 800,
        },
      );
    });
  });
// data: 입력받은 이미지 파일
const convertImageToCanvas = async (data) => {
  if (!data) return null;
  let image;
  if (typeof data === 'object' && 'name' in data) {
    image = data;
  } else {
    image = dataURLtoBlob(`data:image/png;base64,${data}`);
  }
  const cvsImg = await asyncLoadImage(image);
  return cvsImg;
};

const dataURItoBlob = (dataURI) => {
  const byteString = atob(dataURI.split(',')[1]);

  const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  const bb = new Blob([ab], { type: mimeString });
  return bb;
};
const arrayUnique = (array, k = '') =>
  array.filter((value, index, self) => {
    if (k) {
      return self.findIndex((item) => item[k] === value[k]) === index;
    }
    return self.indexOf(value) === index;
  });

const encodeGetParams = (p) =>
  Object.entries(p)
    .map((kv) => kv.map(encodeURIComponent).join('='))
    .join('&');

const getHeaders = (method, body) => {
  const headers = {
    method,
    headers: {
      Accept: 'application/json, text/plain, */*',
      'Content-Type': 'application/json',
    },
  };
  if (body) {
    headers.body = JSON.stringify(body);
  }
  return headers;
};

const setLocalStorage = (name, value) => {
  const preData = localStorage.getItem(name);
  if (preData) {
    const obj = JSON.parse(preData);
    localStorage.setItem(name, JSON.stringify({ ...obj, ...value }));
  }
  localStorage.setItem(name, JSON.stringify(value));
};

const setCurrentUser = (user) =>
  new Promise((resolve) => {
    const preData = localStorage.getItem('currentUser');
    if (preData) {
      const cuObj = JSON.parse(preData);
      return resolve(
        localStorage.setItem(
          'currentUser',
          JSON.stringify({ ...cuObj, ...user }),
        ),
      );
    }
    const { userId, robots, nickName, userPId, institution } = user;
    return resolve(
      localStorage.setItem(
        'currentUser',
        JSON.stringify({
          userId: userId || '',
          nickName: nickName || '',
          robots: robots || [],
          userPId: userPId || '',
          institution: institution || '',
        }),
      ),
    );
  });

const setUserToken = (userToken) =>
  new Promise((resolve) =>
    resolve(localStorage.setItem('userToken', userToken)),
  );

const getUserToken = () => localStorage.getItem('userToken');

const getNickName = () => {
  const currentUser = localStorage.getItem('currentUser');
  const parsedData = JSON.parse(currentUser);
  if (parsedData && 'nickName' in parsedData) {
    const { nickName } = parsedData;
    return nickName;
  }
  return '';
};

const getRobots = () => {
  const currentUser = localStorage.getItem('currentUser');
  const parsedData = JSON.parse(currentUser);
  if (parsedData && 'robots' in parsedData) {
    const { robots } = parsedData;
    return robots;
  }
  return [];
};

const getSerials = () => {
  const robots = getRobots();
  if (robots) {
    const serials = robots.map(({ robotId }) => robotId);
    return serials;
  }
  return [];
};

const getRobotIds = () => {
  const robots = getRobots();
  if (robots) {
    const serials = robots.map(({ _id: id }) => id);
    return serials;
  }
  return [];
};

const getManagerRobotId = () => {
  return JSON.parse(localStorage.getItem('robotPId'));
};

const getManagerRobotSerial = () => {
  return JSON.parse(localStorage.getItem('robotId'));
};

const getManagerMode = () => {
  return localStorage.getItem('manager') === 'true';
};

const getUserId = () => {
  const currentUser = localStorage.getItem('currentUser');
  const parsedData = JSON.parse(currentUser);
  if (parsedData && 'userId' in parsedData) {
    const { userId } = parsedData;
    return userId;
  }
  return '';
};

const getUserPId = () => {
  const currentUser = localStorage.getItem('currentUser');
  const parsedData = JSON.parse(currentUser);
  if (parsedData && 'userPId' in parsedData) {
    const { userPId } = parsedData;
    return userPId;
  }
  return '';
};

const getUserRole = () => {
  const currentUser = localStorage.getItem('currentUser');
  const parsedData = JSON.parse(currentUser);
  if (parsedData && 'role' in parsedData) {
    const { role } = parsedData;
    return role;
  }
  return '';
};

const getInstitution = () => {
  const currentUser = localStorage.getItem('currentUser');
  const parsedData = JSON.parse(currentUser);
  if (parsedData && 'institution' in parsedData) {
    const { institution } = parsedData;
    return institution;
  }
  return '';
};

const getMobileOS = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return 'Windows Phone';
  }

  if (/android/i.test(userAgent)) {
    return 'Android';
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'iOS';
  }

  return 'unknown';
};

const getMobileDevice = () => {
  let hasTouchScreen = false;

  if ('maxTouchPoints' in navigator) {
    hasTouchScreen = navigator.maxTouchPoints > 0;
  } else if ('msMaxTouchPoints' in navigator) {
    hasTouchScreen = navigator.msMaxTouchPoints > 0;
  } else {
    var mQ = window.matchMedia && matchMedia('(pointer:coarse)');
    if (mQ && mQ.media === '(pointer:coarse)') {
      hasTouchScreen = !!mQ.matches;
    } else if ('orientation' in window) {
      hasTouchScreen = true; // deprecated, but good fallback
    } else {
      // Only as a last resort, fall back to user agent sniffing
      var UA = navigator.userAgent;
      hasTouchScreen =
        /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) ||
        /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA);
    }
  }

  return hasTouchScreen;
};

// LCC DFS 좌표변환 ( code : "toXY"(위경도->좌표, v1:위도, v2:경도), "toLL"(좌표->위경도,v1:x, v2:y) )
const getXY = (lat, lng) => {
  // LCC DFS 좌표변환을 위한 기초 자료
  const RE = 6371.00877; // 지구 반경(km)
  const GRID = 5.0; // 격자 간격(km)
  const SLAT1 = 30.0; // 투영 위도1(degree)
  const SLAT2 = 60.0; // 투영 위도2(degree)
  const OLON = 126.0; // 기준점 경도(degree)
  const OLAT = 38.0; // 기준점 위도(degree)
  const XO = 43; // 기준점 X좌표(GRID)
  const YO = 136; // 기1준점 Y좌표(GRID)
  const DEGRAD = Math.PI / 180.0;
  const re = RE / GRID;
  const slat1 = SLAT1 * DEGRAD;
  const slat2 = SLAT2 * DEGRAD;
  const olon = OLON * DEGRAD;
  const olat = OLAT * DEGRAD;

  let sn =
    Math.tan(Math.PI * 0.25 + slat2 * 0.5) /
    Math.tan(Math.PI * 0.25 + slat1 * 0.5);
  sn = Math.log(Math.cos(slat1) / Math.cos(slat2)) / Math.log(sn);
  let sf = Math.tan(Math.PI * 0.25 + slat1 * 0.5);
  sf = (sf ** sn * Math.cos(slat1)) / sn;
  let ro = Math.tan(Math.PI * 0.25 + olat * 0.5);
  ro = (re * sf) / ro ** sn;
  const rs = { lat, lng };
  let ra = Math.tan(Math.PI * 0.25 + lat * DEGRAD * 0.5);
  ra = (re * sf) / ra ** sn;
  let theta = lng * DEGRAD - olon;
  if (theta > Math.PI) theta -= 2.0 * Math.PI;
  if (theta < -Math.PI) theta += 2.0 * Math.PI;
  theta *= sn;
  rs.x = Math.floor(ra * Math.sin(theta) + XO + 0.5);
  rs.y = Math.floor(ro - ra * Math.cos(theta) + YO + 0.5);
  return rs;
};

const isNullOrEmpty = (something) => {
  if (!something) return true;
  if (!Object.keys(something).length) return true;
  return false;
};

// const getStatus = async () => {
//   const res = await fetch(`${DAPI_URL}cache`);
//   const result = await res.json();
//   return result;
// };

let termsResult;
const termsGetData = async () => {
  if (termsResult) return termsResult;
  const termsList = ['Term', 'Privacy', 'Location'];

  const loadTerms = (entries) =>
    Promise.all(entries.map((entry) => import(`../services/Sign${entry}.md`)));

  const result = await loadTerms(termsList);
  const results = await result.map(async ({ default: item }) => {
    const res = await fetch(item);
    return res.text();
  });
  termsResult = await Promise.all(results);
  return termsResult;
};

const getIndex = (n) => (n / 1000000).toFixed(6).split('.')[1];

const Confirm = (msg) => confirm(msg);
const Alert = (msg) => alert(msg);
const Log = (msg) => console.log(msg);
const numberWithCommas = (x) =>
  x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
const telNoFormats = (v) =>
  v &&
  v
    .replace(/[^0-9]/g, '')
    .replace(/^(\d{0,3})(\d{0,4})(\d{0,4})$/g, '$1-$2-$3')
    .replace(/(\-{1,2})$/g, '');

export {
  termsGetData,
  getXY,
  convertImageToCanvas,
  dataURItoBlob,
  getHeaders,
  encodeGetParams,
  setLocalStorage,
  getManagerRobotId,
  getManagerRobotSerial,
  getManagerMode,
  setCurrentUser,
  setUserToken,
  getUserToken,
  getNickName,
  getRobots,
  getRobotIds,
  getSerials,
  getUserId,
  getUserPId,
  getUserRole,
  getInstitution,
  getMobileOS,
  getMobileDevice,
  getCachedData,
  deleteOldCaches,
  arrayUnique,
  isNullOrEmpty,
  Confirm,
  Alert,
  Log,
  getIndex,
  numberWithCommas,
  telNoFormats,
};
